/**
 * WordPress Native Email Sending
 * Unlimited emails using WordPress wp_mail function
 */

/**
 * Send email using WordPress REST API
 * @param {Object} formData - Form data object
 * @returns {Promise} - Promise that resolves with email result
 */
async function sendWordPressEmail(formData) {
    try {
        // console.log('Sending WordPress email with data:', formData);
        
        const response = await fetch('/wp-json/fantastic-windows/v1/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                form_data: formData
            })
        });

        console.log('WordPress API response status:', response.status);
        
        if (!response.ok) {
            const errorText = await response.text();
            console.error('WordPress API error response:', errorText);
            throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
        }

        const result = await response.json();
        // console.log('WordPress API success response:', result);
        return result;
    } catch (error) {
        console.error('WordPress email sending failed:', error);
        throw error;
    }
}

/**
 * Send contact form email to customer and team
 * @param {Object} formData - Form data object
 * @returns {Promise} - Promise that resolves with email result
 */
async function sendContactFormEmails(formData) {
    try {
        console.log('Sending WordPress emails for:', formData);
        
        const result = await sendWordPressEmail(formData);
        
        if (result.status === 'success') {
            console.log('WordPress emails sent successfully:', result);
            return result;
        } else {
            throw new Error('Email sending failed: ' + result.message);
        }
    } catch (error) {
        console.error('Contact form email sending failed:', error);
        throw error;
    }
}

/**
 * Send quote request email to customer and team
 * @param {Object} formData - Form data object
 * @returns {Promise} - Promise that resolves with email result
 */
async function sendQuoteRequestEmails(formData) {
    try {
        console.log('Sending WordPress quote emails for:', formData);
        
        const result = await sendWordPressEmail(formData);
        
        if (result.status === 'success') {
            console.log('WordPress quote emails sent successfully:', result);
            return result;
        } else {
            throw new Error('Quote email sending failed: ' + result.message);
        }
    } catch (error) {
        console.error('Quote request email sending failed:', error);
        throw error;
    }
}

/**
 * Send email using prepared email object (for use with getEmailObject)
 * @param {Object} formData - Original form data object
  * @param {string} emailType - Type of email to send ('customer' or 'team')
 * @returns {Promise} - Promise that resolves with email result
 */
async function sendPreparedEmail(formData, emailType = 'team') {
    try {
        const emailData = { ...formData };

        const response = await fetch('/wp-json/fantastic-windows/v1/send-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                form_data: emailData,
                email_type: emailType // Use the provided email type
            })
        });

        console.log('WordPress API response status:', response.status);

        if (!response.ok) {
            const errorText = await response.text();
            console.error('WordPress API error response:', errorText);
            throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
        }

        const result = await response.json();
        console.log('WordPress API success response:', result);
        return result;
    } catch (error) {
        console.error('Prepared email sending failed:', error);
        throw error;
    }
}
// Export functions for use in other modules
export { sendWordPressEmail, sendContactFormEmails, sendQuoteRequestEmails, sendPreparedEmail };